<template>
  <section>
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'AllApprovalPendingCases',
        }"
      >
        <router-link
          :to="{
            name: 'AllApprovalPendingCases',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'PendingApprovalPendingCases',
            query: this.$route.query,
          }"
        >
          PENDING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'CompleteApprovalPendingCases',
            query: this.$route.query,
          }"
        >
          APPROVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'RejectedApprovalPendingCases',
            query: this.$route.query,
          }"
        >
          REJECTED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
